import { Component, OnInit } from '@angular/core';
import { QuestionComponentBase } from 'src/app/model/QuestionComponentBase';
import { ArrayUtils } from 'src/app/utils/arrays';
import { PlaceholderAnswer, V3Images, V3ImagesAnswerHolder } from '../../../../model/v3/cspa';
import { QuestionService } from '../../../../services/api/impl/rest/question.service';
import { PictureCardItem } from './picture-card/picture-card.component';
import {LogsService} from "../../../../../utils/services/logs.service";
import { AuthorizationServiceProvider } from 'src/app/auth_profile/services/authorization-service.provider';

@Component({
    selector: 'pic',
    templateUrl: './pic.component.html',
    styleUrls: ['./pic.component.scss'],
    standalone: false
})
export class PicComponent  extends QuestionComponentBase<V3ImagesAnswerHolder, V3Images> implements OnInit {

  pictures: PictureCardItem[] = [];
  selectedParis: Array<[PictureCardItem, PictureCardItem]> = [];
  selectedItem: PictureCardItem = null;

  constructor(private questionService: QuestionService,
              logs: LogsService,
              authProvider: AuthorizationServiceProvider) {
      super(logs, authProvider);
  }

  ngOnInit() {
    this.questionSubscription = this.questionService.answerRequest.subscribe(sendAnswer => {
      sendAnswer &&
      sendAnswer['answerType'] === 'V3Images' &&
      sendAnswer['getNewAnswer'] === true &&
      this.getAnswerForSubmit()
    })
      this.prepareQuestionData()
  }

  getAnswerForSubmit() {
    this.applySelectedPairsOnAnswer();
    if(this.answer.answers)
      this.sendAnswer()
  }

  setUpAnswer(answer: V3ImagesAnswerHolder) {
    if (!answer) {
      this.answer = { answers: [] };
    } else {
      this.answer = answer;
    }
    this.readSelectionsFromAnswer();
  }

  readSelectionsFromAnswer() {
    this.selectedParis = [];
    if (!this.pictures || this.pictures.length === 0 || !this.answer) {
      return;
    }

    this.pictures.forEach( p => {
      p.reversed = false;
      p.selected = false;
    });

    for (const answerEntry of this.answer.answers.filter( e => e.name && e.val && e.val.length === 1)) {
      const answerWordItem = this.pictures.find( p => p.word === answerEntry.name );
      const answerImageItem = this.pictures.find( p => p.image === answerEntry.val[0]);

      if (answerImageItem && answerWordItem) {
        answerWordItem.reversed = answerImageItem.reversed = true;
        this.selectedParis.push([answerWordItem, answerImageItem]);
      }
    }
  }

  applySelectedPairsOnAnswer() {
    if (!this.answer) {
      return;
    }

    this.answer.answers = [];
    this.answer.answers = this.selectedParis.map( ([l, r]) => {
      const word = l.word ? l.word : r.word;
      const image = l.image ? l.image : r.image;
      return {
        name: word,
        val: [image],
        alt: [],
      } as PlaceholderAnswer;
    });
  }

  prepareQuestionData(): void {
    if (!this.question) {
      return;
    }

    const questionDef = this.question.questionDef as V3Images
    this.pictures = questionDef.words
      .map( word => new PictureCardItem(word, null)).concat(
        questionDef.images.map(
          image => new PictureCardItem(null, image)
        )
      );
    ArrayUtils.shuffleArray(this.pictures);
    this.readSelectionsFromAnswer();
  }

  onCardClick(item: PictureCardItem) {
    const foundInPairIndex = this.selectedParis.findIndex( ([w, i]) => item === w || item === i);
    // if found in selected paris remove the pair,
    // unselect what is selected and select clicked item only
    if (foundInPairIndex >= 0) {
      this.selectedParis[foundInPairIndex][0].reversed = false;
      this.selectedParis[foundInPairIndex][1].reversed = false;
      this.selectedParis.splice(foundInPairIndex, 1);
      if (this.selectedItem ) {
        this.selectedItem.selected = false;
      }
      this.selectedItem = item;
      item.selected = true;
    } else if (this.selectedItem == null) {
      // if nothing is selected
      item.selected = true;
      this.selectedItem = item;
    } else if (item === this.selectedItem) {
      // on selected item click unselect it
      item.selected = false;
      this.selectedItem = null;
    } else if (
      (item.image == null && this.selectedItem.image == null)
      || (item.word == null && this.selectedItem.word == null)
    ) {
      // both clicked are the same type, unselect previous
      this.selectedItem.selected = false;
      item.selected = true;
      this.selectedItem = item;
    } else {
      // correct pair was selected
      this.selectedItem.selected = item.selected = false;
      this.selectedItem.reversed = item.reversed = true;
      this.selectedParis.push([this.selectedItem, item]);
      this.selectedItem = null;
    }
    if(this.selectedParis.length === this.pictures.length/2)
      this.inProgressEmitter.emit(false)
    else
      this.inProgressEmitter.emit(true)
  }
}
